import { h } from 'preact';

export default props => (
	<svg width="21" height="20" viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M10.0612 1.66663H2.1665V9.56136H10.0612V1.66663Z" fill="#F25022" />
		<path d="M10.0612 10.4386H2.1665V18.3333H10.0612V10.4386Z" fill="#00A4EF" />
		<path d="M18.8332 1.66663H10.9385V9.56136H18.8332V1.66663Z" fill="#7FBA00" />
		<path d="M18.8332 10.4386H10.9385V18.3333H18.8332V10.4386Z" fill="#FFB900" />
	</svg>
);
